var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetskijFitnes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 44.001,
    height: 45.977,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4.98 5.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0,.fil4{fill:#1a2b63;fill-rule:nonzero}.fil4{fill:#4874cc}.fil2,.fil3,.fil9{fill:#c7e7f3;fill-rule:nonzero}.fil2,.fil9{fill:#e8f8fc}.fil9{fill:#ffac00}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2792227200256"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 3.35c.05-.2.08-.42.08-.64C4.98 1.33 3.87.22 2.49.22 1.11.22 0 1.33 0 2.71c0 .22.03.44.08.64h4.81zm0 0z",
    className: "fil0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.89 4.62c.43.37.99.59 1.6.59.61 0 1.17-.22 1.6-.59H.88zm0 0z",
    style: {
      fill: "#293d7c",
      fillRule: "nonzero"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 4.62H.88c.38.32.86.53 1.38.58-.23-.11-.22-.48.02-.58zm0 0z",
    className: "fil0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76.75V.26c0-.15-.12-.27-.27-.27-.15 0-.27.12-.27.27v.49h.53zm0 0z",
    className: "fil2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49.52c-.12 0-.22-.07-.27-.17v.4h.53v-.4c-.05.1-.15.17-.27.17zm0 0z",
    className: "fil3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44 2.8H.53c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h3.91c.15 0 .27-.12.27-.27 0-.15-.12-.27-.27-.27zm0 0z",
    className: "fil4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.85 3.07c0-.15.12-.27.27-.27H.54c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.58c-.15 0-.27-.12-.27-.27zm0 0z",
    style: {
      fill: "#275faf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05 2.28H.92c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h3.13c.15 0 .27-.12.27-.27 0-.15-.12-.27-.27-.27zm0 0z",
    style: {
      fill: "#5891ed",
      fillRule: "nonzero"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24 2.55c0-.15.12-.27.27-.27H.93c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.58c-.15 0-.27-.12-.27-.27zm0 0z",
    className: "fil4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.93 2.03c0-.15-.12-.27-.27-.27H1.32c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h2.34c.15 0 .27-.12.27-.27zm0 0z",
    style: {
      fill: "#dd377b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64 2.03c0-.15.12-.27.27-.27h-.58c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.58c-.15 0-.27-.12-.27-.27zm0 0z",
    style: {
      fill: "#c41672",
      fillRule: "nonzero"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53 1.51c0-.15-.12-.27-.27-.27H1.7c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h1.56c.15 0 .27-.12.27-.27zm0 0z",
    className: "fil9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.03 1.51c0-.15.12-.27.27-.27h-.58c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.58c-.15 0-.27-.12-.27-.27zm0 0z",
    style: {
      fill: "#ff8500",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14.99c0-.15-.12-.27-.27-.27H2.1c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.77c.15 0 .27-.12.27-.27zm0 0z",
    style: {
      fill: "#ffcd38",
      fillRule: "nonzero"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42.99c0-.15.12-.27.27-.27h-.58c-.15 0-.27.12-.27.27 0 .15.12.27.27.27h.58c-.15 0-.27-.12-.27-.27zm0 0z",
    className: "fil9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.42 4.1c.13.2.3.38.48.53h3.17c.19-.15.35-.33.48-.53H.42zm0 0z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.88 4.37c0-.1.06-.19.14-.24-.01-.01-.02-.02-.03-.02H.42c.13.2.3.38.48.53h.17a.27.27 0 0 1-.2-.27zm0 0z",
    style: {
      fill: "#a6d6eb",
      fillRule: "nonzero"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M.44 4.13h4.1c.06-.09.12-.18.17-.28H.27c.05.1.11.19.17.28zm0 0z",
    className: "fil2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M.94 3.99c0-.07.04-.12.1-.15H.27c.05.1.11.19.17.28h.58a.16.16 0 0 1-.08-.14zm0 0z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.08 3.33c.05.18.11.36.2.52h4.43c.09-.16.15-.34.2-.52-.02-.01-.04-.01-.07-.01H.15c-.02 0-.04 0-.07.01zm0 0z",
    style: {
      fill: "#60d882",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.46 3.59c0-.14.11-.26.25-.27H.14c-.02 0-.04 0-.07.01.05.18.11.36.2.52h.44c-.15 0-.27-.12-.27-.27zm0 0z",
    style: {
      fill: "#37c47a",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetskijFitnes);
export default __webpack_public_path__ + "static/media/detskij-fitnes.4d868fe008a94d017252845490d49789.svg";
export { ForwardRef as ReactComponent };